import { INITIAL_STATE, setTimeEntries, mergeTimeEntries, addTimeEntry, deleteTimeEntry } from '../core'
import {
    RECEIVE_TIME_ENTRIES,
    MERGE_TIME_ENTRIES,
    RECEIVE_TIME_ENTRY,
    REMOVE_TIME_ENTRY,
} from '../action_creators'

function timeEntries(state=INITIAL_STATE.timeEntries, action) {
    switch (action.type) {
        case RECEIVE_TIME_ENTRIES:
            return setTimeEntries(state, action.timeEntries)
        case MERGE_TIME_ENTRIES:
            return mergeTimeEntries(state, action.timeEntries)
        case RECEIVE_TIME_ENTRY:
            return addTimeEntry(state, action.timeEntry)
        case REMOVE_TIME_ENTRY:
            return deleteTimeEntry(state, action.timeEntry)
        default:
            return state
    }
}

export default timeEntries


// WEBPACK FOOTER //
// ./src/redux/reducers/time_entries_reducer.js